<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="序列编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'seriesnumber', validatorRules.seriesnumber]" placeholder="请输入序列编号"></a-input>
        </a-form-item>
        <a-form-item label="序列名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'series', validatorRules.series]" placeholder="请输入序列名称"></a-input>
        </a-form-item>
        <a-form-item label="套路编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'routinenumber', validatorRules.routinenumber]" placeholder="请输入套路编号"></a-input>
        </a-form-item>
        <a-form-item label="套路名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'routine', validatorRules.routine]" placeholder="请输入套路名称"></a-input>
        </a-form-item>
        <a-form-item label="样块编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'sampleplatenumber', validatorRules.sampleplatenumber]" placeholder="请输入样块编号"></a-input>
        </a-form-item>
        <a-form-item label="样块名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'sampleplate', validatorRules.sampleplate]" placeholder="请输入样块名称"></a-input>
        </a-form-item>
        <a-form-item label="基材" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'basematerial', validatorRules.basematerial]" placeholder="请输入基材"></a-input>
        </a-form-item>
        <a-form-item label="面材" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'facematerial', validatorRules.facematerial]" placeholder="请输入面材"></a-input>
        </a-form-item>
        <a-form-item label="样板图片地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'imageurl', validatorRules.imageurl]" placeholder="请输入样板图片地址"></a-input>
        </a-form-item>
        <a-form-item label="720度效果图地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'url', validatorRules.url]" placeholder="请输入720度效果图地址"></a-input>
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="[ 'sort', validatorRules.sort]" placeholder="请输入排序" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="创建者" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'createBy', validatorRules.createBy]" placeholder="请输入创建者"></a-input>
        </a-form-item>
        <a-form-item label="创建日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择创建日期" v-decorator="[ 'createDate', validatorRules.createDate]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="更新者" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'updateBy', validatorRules.updateBy]" placeholder="请输入更新者"></a-input>
        </a-form-item>
        <a-form-item label="更新日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择更新日期" v-decorator="[ 'updateDate', validatorRules.updateDate]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remarks', validatorRules.remarks]" placeholder="请输入备注"></a-input>
        </a-form-item>
        <a-form-item label="删除标志" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'delFlag', validatorRules.delFlag]" placeholder="请输入删除标志"></a-input>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  
  
  export default {
    name: "GisOrangehomeGalleryBaseinfoModal",
    components: { 
      JDate,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          seriesnumber: {rules: [
          ]},
          series: {rules: [
          ]},
          routinenumber: {rules: [
          ]},
          routine: {rules: [
          ]},
          sampleplatenumber: {rules: [
          ]},
          sampleplate: {rules: [
          ]},
          basematerial: {rules: [
          ]},
          facematerial: {rules: [
          ]},
          imageurl: {rules: [
          ]},
          url: {rules: [
          ]},
          sort: {rules: [
          ]},
          createBy: {rules: [
          ]},
          createDate: {rules: [
          ]},
          updateBy: {rules: [
          ]},
          updateDate: {rules: [
          ]},
          remarks: {rules: [
          ]},
          delFlag: {rules: [
          ]},
        },
        url: {
          add: "/jpgallery.base/gisOrangehomeGalleryBaseinfo/add",
          edit: "/jpgallery.base/gisOrangehomeGalleryBaseinfo/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'seriesnumber','series','routinenumber','routine','sampleplatenumber','sampleplate','basematerial','facematerial','imageurl','url','sort','createBy','createDate','updateBy','updateDate','remarks','delFlag'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'seriesnumber','series','routinenumber','routine','sampleplatenumber','sampleplate','basematerial','facematerial','imageurl','url','sort','createBy','createDate','updateBy','updateDate','remarks','delFlag'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>